import apiFetch from '../../apiFetch'

export default function (dossierBudgetRatingId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/dossierBudgetRating/${dossierBudgetRatingId}`, body: null, method: 'DELETE', token: token, lastAccessDate })
}
